export function mockGetApiPath() {
    return process.env.API_ENDPOINT_PATH || 'api';
}
